import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FloatingInput, FloatingTextarea } from "../components/FloatingLabels";
import mailBox from "../assets/mailbox.png";

const services = [
    "Digital Product Development",
    "Web & Mobile Applications",
    "Intelligent Systems & Automation",
    "IoT & Connected Technologies",
    "UI/UX Design & Branding",
    "Digital Marketing & Growth",
    "Careers & Opportunities",
    "CareerConnect AI",
    "CareerConnect ATS",
    "HRMS",
    "LMS",
    "Other",
];

export default function ContactForm({ onClose }) {

    const location = useLocation();
    const beURL = process.env.REACT_APP_URL

    const [requestDemo, setRequestDemo] = useState(false);

    const [form, setForm] = useState({
        name: "",
        company: "",
        email: "",
        phone: "",
        project: "",
        service: "",
    });

    const [errors, setErrors] = useState({});
    const [open, setOpen] = useState(false);
    const [sucessForm, setSuccessForm] = useState(false);
    const [response, setResponse] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");


    /*  PRODUCT PAGE CHECK*/
    useEffect(() => {

        const productPages = {
            "/product/ccai": "CareerConnect AI",
            "/product/ccats": "CareerConnect ATS",
            "/product/lms": "LMS",
            "/product/hrms": "HRMS",
        };

        if (productPages[location.pathname]) {

            setRequestDemo(true);

            setForm((prev) => ({
                ...prev,
                service: productPages[location.pathname],
            }));

        } else {
            setRequestDemo(false);
        }

    }, [location.pathname]);

    /*  VALIDATION*/

    const validate = () => {

        let err = {};

        if (!form.name)
            err.name = "Name is required";

        if (!form.email)
            err.email = "Email is required";

        else if (!/\S+@\S+\.\S+/.test(form.email))
            err.email = "Invalid email";

        if (!form.phone)
            err.phone = "Phone is required";

        if (!form.service)
            err.service = "Select a service";


        setErrors(err);

        return Object.keys(err).length === 0;
    };

    /*  INPUT CHANGE  */

    const handleChange = (e) => {

        const { name, value } = e.target;

        // PHONE VALIDATION
        if (name === "phone") {

            if (/^\d*$/.test(value)) {

                setForm((prev) => ({
                    ...prev,
                    [name]: value,
                }));

                // REMOVE ERROR
                if (value.trim()) {

                    setErrors((prev) => ({
                        ...prev,
                        phone: "",
                    }));
                }
            }

            return; // IMPORTANT
        }

        // OTHER FIELDS
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));

        // REMOVE ERROR
        if (value.trim()) {

            setErrors((prev) => ({
                ...prev,
                [name]: "",
            }));
        }
    };

    /* SUBMIT  */

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validate()) return;

        try {

            setErrorMessage("");

            const res = await fetch(`${beURL}/mailRouter`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify({
                    name: form.name,
                    company: form.company,
                    phone: form.phone,
                    mail: form.email,
                    project: form.project,
                    service: form.service,
                }),
            });

            const data = await res.json();

            if (data.success) {

                setResponse(true);
                setSuccessForm(true);

            } else {

                setResponse(false);
                setSuccessForm(false);

                setErrorMessage(
                    data.message ||
                    "Enquiry was not submitted. Please try again later."
                );
            }

        } catch (error) {

            console.error("Enquiry Error:", error);

            setResponse(false);
            setSuccessForm(false);

            setErrorMessage(
                "Enquiry was not submitted. Please try again later."
            );
        }
    };

    return (
        <div
            onClick={onClose}
            className="fixed top-[70px] md:top-[98px] left-0 w-full h-[calc(100vh-70px)] md:h-[calc(100vh-98px)] flex justify-center z-50 overflow-y-auto bg-black/5 backdrop-blur-sm px-3 sm:px-4 py-4 md:py-10"
        >

            {/* CARD */}
            <div
                onClick={(e) => e.stopPropagation()}
                className={`bg-secondary-50 w-full max-w-md sm:max-w-xl md:max-w-2xl lg:max-w-md h-full md:h-auto ${open ? 'max-h-full' :'mex-w-auto'} rounded-xl md:rounded-2xl shadow-xl border border-primary-600 flex flex-col`}
            >

                {/* ================= FORM / SUCCESS ================= */}

                {/* <div className="flex-1 flex items-center justify-center p-8">
                    <div className="text-center max-w-lg">

                        

                        <h2 className="text-3xl font-semibold text-gray-900 mb-4">
                            Let's Talk
                        </h2>

                        <p className="text-gray-600 leading-7 mb-6">
                            Thank you for your interest in SAN Technovation.
                            Our inquiry portal is currently under development.
                        </p>

                        <p className="text-gray-600 leading-7 mb-8">
                            For service inquiries, project discussions, partnership opportunities,
                            or support requests, please reach out to us via email. Our team will
                            respond as soon as possible.
                        </p>

                        <a
                            href="mailto:info@santechnovation.com"
                            className="inline-flex items-center px-6 py-3 rounded-lg bg-primary-600 text-white font-medium hover:bg-blue-700 transition"
                        >
                            Contact via Email
                        </a>

                        <p className="text-sm text-gray-400 mt-5">
                            We're working hard to launch our online inquiry system soon.
                        </p>

                    </div>
                </div> */}

                {!sucessForm && (

                    <div className="flex-1 overflow-scroll scrollbar-hide p-4 sm:p-6 md:px-8">


                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-center">
                            {requestDemo
                                ? "Request a Product Demo"
                                : "Let’s Talk About Your Idea"}
                        </h2>

                        <p className="text-xs sm:text-sm md:text-base text-center text-gray-500 mt-2 mb-6 md:mb-8 font-secondary">
                            {requestDemo
                                ? `You're requesting a demo for ${form.service}. Our team will contact you shortly.`
                                : "Tell us a little about what you're building. Our team will get back to you shortly."}
                        </p>

                        <form className="space-y-5 md:space-y-6">

                            {!requestDemo && (

                                <>
                                    <div className="grid grid-cols-1  gap-4 md:gap-6">

                                        <FloatingInput
                                            label="Full Name"
                                            name="name"
                                            value={form.name}
                                            onChange={handleChange}
                                            error={errors.name}
                                            badge=" *"
                                        />

                                        <FloatingInput
                                            label="Company Name"
                                            name="company"
                                            value={form.company}
                                            onChange={handleChange}
                                        />

                                        <FloatingInput
                                            label="Email Address"
                                            name="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            error={errors.email}
                                            badge=" *"
                                        />

                                        <FloatingInput
                                            label="Phone Number"
                                            name="phone"
                                            value={form.phone}
                                            onChange={handleChange}
                                            error={errors.phone}
                                            badge=" *"
                                        />
                                    </div>


                                    <FloatingTextarea
                                        label="Project Requirement"
                                        name="project"
                                        value={form.project}
                                        onChange={handleChange}
                                    />


                                    <div className="relative">

                                        <div
                                            onClick={() => setOpen(!open)}
                                            className={`flex justify-between items-center rounded-lg px-4 py-2.5 md:py-3 text-xs md:text-sm cursor-pointer bg-white border ${errors.service
                                                ? "border-red-500"
                                                : "border-gray-300"
                                                }`}
                                        >

                                            {form.service || "Service Interested In"}

                                            <RiArrowDropDownLine
                                                className={`
                                                text-2xl
                                                transition-transform duration-300
                                                ${open ? "rotate-180" : "rotate-0"}
                                            `}
                                            />
                                        </div>

                                        <AnimatePresence>
                                            {open && (
                                                <motion.div
                                                    initial={{ opacity: 0, y: -10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    exit={{ opacity: 0 }}
                                                    className="absolute w-full bg-white shadow-lg rounded-lg mt-2 z-50 max-h-40 sm:max-h-48 md:max-h-60 overflow-y-auto text-sm md:text-base"
                                                >
                                                    {services.map((item, i) => (
                                                        <div
                                                            key={i}
                                                            onClick={() => {
                                                                setForm({
                                                                    ...form,
                                                                    service: item,
                                                                });

                                                                setOpen(false);
                                                            }}
                                                            className="px-4 py-2.5 md:py-3 hover:bg-blue-50 cursor-pointer text-sm"
                                                        >
                                                            {item}
                                                        </div>
                                                    ))}
                                                </motion.div>
                                            )}
                                        </AnimatePresence>

                                        {errors.service && (
                                            <p className="text-red-500 text-xs md:text-sm mt-1">
                                                {errors.service}
                                            </p>
                                        )}
                                    </div>
                                </>
                            )}


                            {requestDemo && (

                                <div className="space-y-5">

                                    <FloatingInput
                                        label="Full Name"
                                        name="name"
                                        value={form.name}
                                        onChange={handleChange}
                                        error={errors.name}
                                        badge=" *"
                                    />

                                    <FloatingInput
                                        label="Email Address"
                                        name="email"
                                        value={form.email}
                                        onChange={handleChange}
                                        error={errors.email}
                                        badge=" *"
                                    />

                                    <FloatingInput
                                        label="Phone Number"
                                        name="phone"
                                        value={form.phone}
                                        onChange={handleChange}
                                        error={errors.phone}
                                        badge=" *"
                                    />

                                    <div className="relative">

                                        <div
                                            onClick={() => setOpen(!open)}
                                            className={`flex justify-between items-center rounded-lg px-4 py-2.5 md:py-3 text-xs md:text-sm cursor-pointer bg-white border ${errors.service
                                                ? "border-red-500"
                                                : "border-gray-300"
                                                }`}
                                        >

                                            {form.service || "Service Interested In"}

                                            <RiArrowDropDownLine
                                                className={`
                                                text-2xl
                                                transition-transform duration-300
                                                ${open ? "rotate-180" : "rotate-0"}
                                            `}
                                            />
                                        </div>

                                        <AnimatePresence>
                                            {open && (
                                                <motion.div
                                                    initial={{ opacity: 0, y: -10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    exit={{ opacity: 0 }}
                                                    className="absolute w-full bg-white shadow-lg rounded-lg mt-2 z-50 max-h-40 sm:max-h-48 md:max-h-60 overflow-y-scroll scrollbar-hide text-sm md:text-base"
                                                >
                                                    {services.map((item, i) => (
                                                        <div
                                                            key={i}
                                                            onClick={() => {
                                                                setForm({
                                                                    ...form,
                                                                    service: item,
                                                                });

                                                                setOpen(false);
                                                            }}
                                                            className="px-4 py-2.5 md:py-3 hover:bg-blue-50 cursor-pointer text-sm"
                                                        >
                                                            {item}
                                                        </div>
                                                    ))}
                                                </motion.div>
                                            )}
                                        </AnimatePresence>

                                        {errors.service && (
                                            <p className="text-red-500 text-xs md:text-sm mt-1">
                                                {errors.service}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                        </form>
                    </div>

                )}
                {


                    response && sucessForm &&
                    (<div className="flex-1 flex items-center justify-center px-6 py-12">

                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            className="text-center max-w-xl"
                        >


                            <img
                                src={mailBox}
                                alt="success"
                                className="w-40 sm:w-52 mx-auto mb-8"
                            />


                            <h2 className="text-2xl sm:text-3xl font-semibold text-green-600 mb-5">
                                You're all set!
                            </h2>

                            <p className="text-gray-600 text-sm sm:text-base leading-7">
                                Thanks for reaching out — we’re already looking
                                forward to your idea. Our team will review your
                                message and get back to you soon.
                            </p>


                            <button
                                onClick={onClose}
                                className="mt-10 text-blue-600 font-medium"
                            >
                                Back To Site
                            </button>
                        </motion.div>
                    </div>)
                }

                {/* ================= BUTTON ================= */}

                {!sucessForm && (

                    <div className="p-4 pb-6 md:px-8">

                        <button
                            onClick={handleSubmit}
                            className="w-full h-12 bg-blue-600 text-white py-2.5 md:py-3 font-medium text-sm md:text-[14px] rounded-lg hover:bg-blue-700 transition"
                        >
                            {requestDemo
                                ? "Request Demo"
                                : "Let’s Get Started"}
                        </button>

                        {errorMessage && (
                            <div className="mt-4 text-center">
                                <p className="text-red-500 text-sm font-medium">
                                    Unable to submit your enquiry at the moment.
                                </p>

                                <p className="text-gray-500 text-xs sm:text-sm mt-1 leading-relaxed">
                                    Please try again in a few minutes. If the issue persists,
                                    contact us directly at{" "}
                                    <a
                                        href="mailto:info@santechnovation.com"
                                        className="text-primary-600 font-medium hover:underline"
                                    >
                                        info@santechnovation.com
                                    </a>.
                                </p>
                            </div>
                        )}

                        <p className="text-center text-[11px] sm:text-xs md:text-sm text-gray-400 mt-3 md:mt-4">
                            Your data stays safe with us at all times.
                        </p>

                    </div>
                )}
            </div>
        </div>
    );
}